/**
 * Search API Constants
 * Constants used by the search API for type checking and parameter names
 */

// Search type constants - extending the base SearchTypes
export const SearchTypeNames = {
    ADULT_TEAM_CLUBS: 'adultTeamClubs',
    CLUBS: 'clubs',
    COLLEGE_CIRCUITS: 'collegeCircuits',
    COLLEGES: 'colleges',
    EVENTS: 'events',
    EVENTS_NEAR_ME: 'eventsNearMe',
    FLEX_LEAGUES: 'flexLeagues',
    GROUP_PLAY_EVENTS: 'groupPlayEvents',
    HIGH_SCHOOLS: 'highSchools',
    JUNIOR_CIRCUITS: 'juniorCircuits',
    JUNIOR_REGIONALS: 'juniorRegionals',
    PAID_HIT_CLUBS: 'paidHitClubs',
    PAID_HITS: 'paidHits',
    PLAYERS: 'players',
    PRO_TENNIS_TOUR: 'proTennisTour',
    SCHOOLS: 'schools',
    TEAM_LEAGUES: 'teamLeagues',
};

// Groups of search types for filtering logic
export const SearchTypeGroups = {
    // Event types that share common date filtering
    EVENTS_WITH_COMMON_FILTERS: [
        SearchTypeNames.COLLEGE_CIRCUITS,
        SearchTypeNames.EVENTS,
        SearchTypeNames.FLEX_LEAGUES,
        SearchTypeNames.JUNIOR_CIRCUITS,
        SearchTypeNames.JUNIOR_REGIONALS,
        SearchTypeNames.PAID_HITS,
        SearchTypeNames.PRO_TENNIS_TOUR,
        SearchTypeNames.TEAM_LEAGUES,
    ],
    // Types that support location aggregation filters
    LOCATION_FILTER_TYPES: [
        SearchTypeNames.ADULT_TEAM_CLUBS,
        SearchTypeNames.CLUBS,
        SearchTypeNames.COLLEGES,
        SearchTypeNames.EVENTS,
        SearchTypeNames.FLEX_LEAGUES,
        SearchTypeNames.HIGH_SCHOOLS,
        SearchTypeNames.PAID_HIT_CLUBS,
        SearchTypeNames.PLAYERS,
    ],
    // Types that trigger school/club search flag
    SCHOOL_CLUB_SEARCH_TYPES: [
        SearchTypeNames.COLLEGES,
        SearchTypeNames.HIGH_SCHOOLS,
        SearchTypeNames.SCHOOLS,
    ],
};

// API parameter names
export const SearchParamNames = {
    // Basic params
    QUERY: 'query',
    SEARCH_ORIGIN: 'searchOrigin',
    SKIP: 'skip',
    SORT: 'sort',
    TOP: 'top',

    // Location params
    DISTANCE: 'distance',
    LOCATION_COUNTRY_NAME: 'locationCountryName',
    LOCATION_STATE_NAME: 'locationStateName',
    PIN: 'pin',

    // Player filters
    AGE_MAX: 'ageMax',
    AGE_MIN: 'ageMin',
    AGE_TAGS: 'ageTags',
    COLLEGE_ID: 'collegeId',
    CONFERENCE_ID: 'conferenceId',
    DIVISION_ID: 'divisionId',
    GENDER: 'gender',
    GRAD_YEAR_HS: 'gradYearHs',
    NATIONALITY: 'nationality',
    PRIMARY_TAGS: 'primaryTags',

    // UTR filters
    UTR_FIT_POSITION: 'utrFitPosition',
    UTR_FIT_RATING: 'utrFitRating',
    UTR_MAX: 'utrMax',
    UTR_MIN: 'utrMin',
    UTR_RELIABILITY: 'utrReliability',
    UTR_TEAM_TYPE: 'utrTeamType',
    UTR_TYPE: 'utrType',

    // Event filters
    BALL_TYPES: 'ballTypes',
    EVENT_ENTRY_FEES_MAX: 'eventEntryFeesMax',
    EVENT_ENTRY_FEES_MIN: 'eventEntryFeesMin',
    EVENT_PRIZE_MONEY_MAX: 'eventPrizeMoneyMax',
    EVENT_PRIZE_MONEY_MIN: 'eventPrizeMoneyMin',
    EVENT_REGIONS: 'eventRegions',
    EVENT_TYPES: 'eventTypes',
    EVENT_UTR_TYPES: 'eventUtrTypes',
    GENDERS: 'genders',
    HAS_PRIZE_MONEY: 'hasPrizeMoney',
    RANGE: 'range',
    REGION_SEARCH: 'regionSearch',
    SHOW_IN_PROGRESS_EVENTS: 'showInProgressEvents',
    TOURS: 'tours',

    // College filters
    PUBLIC: 'public',

    // School/club search
    SCHOOL_CLUB_SEARCH: 'schoolClubSearch',
};

// Sort directions
export const SortDirections = {
    ASC: 'asc',
    DESC: 'desc',
};

// Public/Private values
export const PublicPrivateValues = {
    PUBLIC: 'public',
    PRIVATE: 'private',
};

// Default values
export const Defaults = {
    DEFAULT_SEARCH_KEY: 'default',
    DEFAULT_SKIP: 0,
    DEFAULT_TOP: 40,
    DEFAULT_UTR_FIT_POSITION: 1,
    DEFAULT_UTR_MAX: 16,
    DEFAULT_UTR_MIN: 1,
    SCHOOL_CLUB_SEARCH_VALUE: 'true',
};

// API endpoints
export const ApiEndpoints = {
    SEARCH_BASE: 'v2/search',
};

// Date format
export const DateFormats = {
    API_DATE: 'MM/DD/YYYY',
};

// Sort field names for event scheduling
export const EventSortFields = {
    END_UTC_DESC: 'eventSchedule.eventEndUtc:desc',
    START_UTC_DESC: 'eventSchedule.eventStartUtc:desc',
};
